import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IngInputBase } from '../../inputs';

@Component({
  selector: 'ing-inputs-container',
  templateUrl: './inputs-container.component.html',
  styleUrls: ['./inputs-container.component.scss']
})
export class InputsContainerComponent implements OnInit {
  @Input() form:  FormGroup;
  @Input() inputs: IngInputBase<any>[];
  @Input() groupId: string;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    if(!!this.inputs) {
      this.inputs = this.inputs.filter(inp => { return inp.groupId == this.groupId });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/inputs-container/inputs-container.component.ts